import { render, staticRenderFns } from "./PhraseLinkEmitClick.vue?vue&type=template&id=7c7df68f&scoped=true"
import script from "./PhraseLinkEmitClick.vue?vue&type=script&lang=ts"
export * from "./PhraseLinkEmitClick.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7df68f",
  null
  
)

export default component.exports